import Draggable from "react-draggable";

import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Paper from "@mui/material/Paper";

import MDButton from "components/MDButton";

import MaterialDetalheCabecalho from "pages/materiais/MaterialDetalheCabecalho";
import MaterialDetalheConteudo from "pages/materiais/MaterialDetalheConteudo";

function PaperComponent(props) {
  return (
    <Draggable handle=".draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} />
    </Draggable>
  );
}

export default function MenuSearchMateriais({ open, onClose, material, centrosSelecionados = [] }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth PaperComponent={PaperComponent}>
      <DialogTitle
        className="draggable-dialog-title"
        sx={{
          p: 0,
          cursor: "move",
        }}
      >
        <MaterialDetalheCabecalho material={material} ativo={open} />
      </DialogTitle>

      <DialogContent
        dividers
        sx={{
          p: 0,
        }}
      >
        <MaterialDetalheConteudo
          material={material}
          centrosSelecionados={centrosSelecionados}
          ativo={open}
        />
      </DialogContent>

      <DialogActions>
        <MDButton color="info" variant="gradient" size="small" onClick={onClose}>
          Fechar
        </MDButton>
      </DialogActions>
    </Dialog>
  );
}
